import React, { useEffect, useState } from 'react';
import Header from './Header';
import API_URL from '../config';

const listaCstIcms = [
  '00', '20', '40', '41', '60', '61', '90', '102', '103', '300', '400', '500', '900'
];
const listaCstPisCofins = [
  '01', '02', '03', '04', '05', '06', '07', '08', '09', '49', '50', '51', '52', '53', '54', '55', '56',
  '60', '61', '62', '63', '64', '65', '66', '67', '70', '71', '72', '73', '74', '75', '98', '99'
];

function ImpostosPage({ empresa, usuario, onVoltar, onSair }) {
  const [fiscais, setFiscais] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState('');
  const [modalAberto, setModalAberto] = useState(false);
  const [form, setForm] = useState({
    id: null,
    nome: '',
    ativo: true,
    integracao: '',
    cfop: '',
    red_bc_icms: '',
    cst_icms: '',
    aliq_icms: '',
    cst_pis: '',
    aliq_pis: '',
    cst_cofins: '',
    aliq_cofins: ''
  });
  const [editando, setEditando] = useState(false);
  const [pesquisa, setPesquisa] = useState('');
  const [confirmarExclusao, setConfirmarExclusao] = useState({ aberto: false, id: null });

  const fetchFiscais = async () => {
    setLoading(true);
    setErro('');
    try {
      const res = await fetch(`${API_URL}/fiscal?empresa_id=${empresa.id}`);
      const data = await res.json();
      setFiscais(data);
    } catch (err) {
      setErro('Erro ao buscar impostos');
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchFiscais();
    // eslint-disable-next-line
  }, [empresa.id]);

  // Função para converter decimal do banco para string crua de duas casas
  function decimalParaMascara(valor) {
    if (valor === undefined || valor === null || valor === '') return '';
    const num = Number(valor);
    if (isNaN(num)) return '';
    return Math.round(num * 100).toString();
  }

  const abrirModal = (fiscal = null) => {
    if (fiscal) {
      setForm({
        id: fiscal.id,
        nome: fiscal.nome,
        ativo: fiscal.ativo,
        integracao: fiscal.integracao,
        cfop: fiscal.cfop,
        red_bc_icms: decimalParaMascara(fiscal.red_bc_icms),
        cst_icms: fiscal.cst_icms,
        aliq_icms: decimalParaMascara(fiscal.aliq_icms),
        cst_pis: fiscal.cst_pis,
        aliq_pis: decimalParaMascara(fiscal.aliq_pis),
        cst_cofins: fiscal.cst_cofins,
        aliq_cofins: decimalParaMascara(fiscal.aliq_cofins)
      });
      setEditando(true);
    } else {
      setForm({
        id: null,
        nome: '',
        ativo: true,
        integracao: '',
        cfop: '',
        red_bc_icms: '',
        cst_icms: '',
        aliq_icms: '',
        cst_pis: '',
        aliq_pis: '',
        cst_cofins: '',
        aliq_cofins: ''
      });
      setEditando(false);
    }
    setErro('');
    setModalAberto(true);
  };

  const fecharModal = () => {
    setModalAberto(false);
    setForm({
      id: null,
      nome: '',
      ativo: true,
      integracao: '',
      cfop: '',
      red_bc_icms: '',
      cst_icms: '',
      aliq_icms: '',
      cst_pis: '',
      aliq_pis: '',
      cst_cofins: '',
      aliq_cofins: ''
    });
    setEditando(false);
    setErro('');
  };

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    if (type === 'checkbox') {
      setForm(f => ({ ...f, [name]: checked }));
    } else {
      setForm(f => ({ ...f, [name]: value }));
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setErro('');
    if (!form.nome) {
      setErro('Preencha o campo Descrição!');
      return;
    }
    try {
      const method = editando ? 'PUT' : 'POST';
      const url = editando ? `${API_URL}/fiscal/${form.id}` : `${API_URL}/fiscal`;
      const red_bc_icms = form.red_bc_icms ? (Number(form.red_bc_icms) / 100) : null;
      const aliq_icms = form.aliq_icms ? (Number(form.aliq_icms) / 100) : null;
      const aliq_pis = form.aliq_pis ? (Number(form.aliq_pis) / 100) : null;
      const aliq_cofins = form.aliq_cofins ? (Number(form.aliq_cofins) / 100) : null;
      const res = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          empresa_id: empresa.id,
          nome: form.nome,
          ativo: form.ativo,
          integracao: form.integracao,
          cfop: form.cfop,
          red_bc_icms,
          cst_icms: form.cst_icms,
          aliq_icms,
          cst_pis: form.cst_pis,
          aliq_pis,
          cst_cofins: form.cst_cofins,
          aliq_cofins
        })
      });
      if (!res.ok) throw new Error('Erro ao salvar imposto');
      fecharModal();
      fetchFiscais();
    } catch (err) {
      setErro('Erro ao salvar imposto');
    }
  };

  const handleDelete = async id => {
    setConfirmarExclusao({ aberto: true, id });
  };

  const confirmarRemocao = async () => {
    try {
      await fetch(`${API_URL}/fiscal/${confirmarExclusao.id}`, { method: 'DELETE' });
      fetchFiscais();
    } catch {
      setErro('Erro ao remover imposto');
    }
    setConfirmarExclusao({ aberto: false, id: null });
  };

  const cancelarRemocao = () => {
    setConfirmarExclusao({ aberto: false, id: null });
  };

  // Filtro de pesquisa
  const fiscaisFiltrados = fiscais.filter(f =>
    (f.nome || '').toLowerCase().includes(pesquisa.toLowerCase()) ||
    (f.cfop || '').toLowerCase().includes(pesquisa.toLowerCase())
  );

  // Função para formatar sempre duas casas decimais
  function formatarDuasCasas(valor) {
    if (valor === undefined || valor === null || valor === '') return '';
    const num = Number(valor);
    if (isNaN(num)) return '';
    return num.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  // Função para máscara dinâmica de duas casas decimais
  function formatarMascaraDuasCasas(valor) {
    if (!valor) return '';
    let apenasNumeros = valor.replace(/\D/g, '');
    if (apenasNumeros.length < 3) {
      apenasNumeros = apenasNumeros.padStart(3, '0');
    }
    const int = apenasNumeros.slice(0, -2);
    const dec = apenasNumeros.slice(-2);
    return Number(int + '.' + dec).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 to-blue-300">
      <Header usuario={usuario} empresa={empresa} onVoltar={onVoltar} onSair={onSair} />
      <div className="max-w-5xl mx-auto mt-10 bg-white rounded-lg shadow-lg p-6 relative">
        <h2 className="text-2xl font-bold text-blue-700 mb-6">Impostos</h2>
        <div className="mb-6 flex justify-end">
          <input
            type="text"
            value={pesquisa}
            onChange={e => setPesquisa(e.target.value)}
            placeholder="Pesquisar por descrição ou CFOP..."
            className="border rounded px-3 py-2 w-full max-w-xs"
          />
        </div>
        {erro && <div className="text-red-600 mb-4">{erro}</div>}
        {loading ? (
          <div>Carregando...</div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {fiscaisFiltrados.map(f => (
              <div key={f.id} className="bg-blue-50 rounded-lg shadow flex flex-col p-4 relative border border-blue-200">
                <div className="flex items-center justify-between mb-2">
                  <span className="font-bold text-blue-800 text-lg">{f.nome}</span>
                  <div className="flex space-x-2">
                    <button onClick={() => abrirModal(f)} title="Editar" className="text-blue-600 hover:text-blue-900">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536M9 13l6-6 3 3-6 6H9v-3z" /></svg>
                    </button>
                    <button onClick={() => handleDelete(f.id)} title="Excluir" className="text-red-600 hover:text-red-900">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
                    </button>
                  </div>
                </div>
                <div className="text-gray-700 mb-1"><b>CFOP:</b> {f.cfop}</div>
                <div className="text-gray-700 mb-1"><b>Red. BC ICMS:</b> {formatarDuasCasas(f.red_bc_icms)}</div>
                <div className="text-gray-700 mb-1"><b>CST ICMS:</b> {f.cst_icms}</div>
                <div className="text-gray-700 mb-1"><b>Aliq. ICMS:</b> {formatarDuasCasas(f.aliq_icms)}</div>
                <div className="text-gray-700 mb-1"><b>CST PIS:</b> {f.cst_pis}</div>
                <div className="text-gray-700 mb-1"><b>Aliq. PIS:</b> {formatarDuasCasas(f.aliq_pis)}</div>
                <div className="text-gray-700 mb-1"><b>CST COFINS:</b> {f.cst_cofins}</div>
                <div className="text-gray-700 mb-1"><b>Aliq. COFINS:</b> {formatarDuasCasas(f.aliq_cofins)}</div>
                <div className="text-gray-700 mb-1"><b>Integração:</b> {f.integracao || '-'}</div>
                <div className="flex justify-between items-center text-gray-700 mb-1">
                  <span><b>Ativo:</b> {f.ativo ? 'Sim' : 'Não'}</span>
                  <span className="text-xs text-gray-500 font-bold">ID: {f.id}</span>
                </div>
              </div>
            ))}
            {fiscaisFiltrados.length === 0 && (
              <div className="col-span-full text-center py-8 text-gray-500">Nenhum imposto encontrado.</div>
            )}
          </div>
        )}
        {/* Botão flutuante adicionar */}
        <button
          onClick={() => abrirModal()}
          className="fixed bottom-8 right-8 bg-blue-600 text-white rounded-full shadow-lg w-16 h-16 flex items-center justify-center text-3xl hover:bg-blue-700 transition z-50"
          title="Adicionar Imposto"
        >
          +
        </button>
        {/* Modal de inclusão/edição */}
        {modalAberto && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-2xl relative">
              <button onClick={fecharModal} className="absolute top-2 right-2 text-gray-500 hover:text-gray-800 text-2xl">&times;</button>
              <h3 className="text-xl font-bold text-blue-700 mb-4">{editando ? 'Editar Imposto' : 'Novo Imposto'}</h3>
              {erro && <div className="text-red-600 mb-2">{erro}</div>}
              <form onSubmit={handleSubmit}>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Descrição*</label>
                    <input name="nome" value={form.nome} onChange={handleChange} className="border rounded px-3 py-2 w-full" />
                  </div>
                  <div className="flex items-center mt-6 md:mt-0">
                    <input type="checkbox" name="ativo" checked={form.ativo} onChange={handleChange} className="mr-2" />
                    <label className="text-sm font-medium text-gray-700">Ativo</label>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Integração</label>
                    <input name="integracao" value={form.integracao} onChange={handleChange} className="border rounded px-3 py-2 w-full" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">CFOP</label>
                    <input name="cfop" value={form.cfop} onChange={handleChange} className="border rounded px-3 py-2 w-full" maxLength={4} />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Red. BC ICMS</label>
                    <input name="red_bc_icms" value={formatarMascaraDuasCasas(form.red_bc_icms)} onChange={e => setForm(f => ({ ...f, red_bc_icms: e.target.value.replace(/\D/g, '') }))} className="border rounded px-3 py-2 w-full" type="text" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">CST ICMS</label>
                    <select name="cst_icms" value={form.cst_icms} onChange={handleChange} className="border rounded px-3 py-2 w-full">
                      <option value="">Selecione...</option>
                      {listaCstIcms.map(cst => <option key={cst} value={cst}>{cst}</option>)}
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Aliq. ICMS</label>
                    <input name="aliq_icms" value={formatarMascaraDuasCasas(form.aliq_icms)} onChange={e => setForm(f => ({ ...f, aliq_icms: e.target.value.replace(/\D/g, '') }))} className="border rounded px-3 py-2 w-full" type="text" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">CST PIS</label>
                    <select name="cst_pis" value={form.cst_pis} onChange={handleChange} className="border rounded px-3 py-2 w-full">
                      <option value="">Selecione...</option>
                      {listaCstPisCofins.map(cst => <option key={cst} value={cst}>{cst}</option>)}
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Aliq. PIS</label>
                    <input name="aliq_pis" value={formatarMascaraDuasCasas(form.aliq_pis)} onChange={e => setForm(f => ({ ...f, aliq_pis: e.target.value.replace(/\D/g, '') }))} className="border rounded px-3 py-2 w-full" type="text" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">CST COFINS</label>
                    <select name="cst_cofins" value={form.cst_cofins} onChange={handleChange} className="border rounded px-3 py-2 w-full">
                      <option value="">Selecione...</option>
                      {listaCstPisCofins.map(cst => <option key={cst} value={cst}>{cst}</option>)}
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Aliq. COFINS</label>
                    <input name="aliq_cofins" value={formatarMascaraDuasCasas(form.aliq_cofins)} onChange={e => setForm(f => ({ ...f, aliq_cofins: e.target.value.replace(/\D/g, '') }))} className="border rounded px-3 py-2 w-full" type="text" />
                  </div>
                </div>
                <div className="flex justify-end mt-6 gap-2">
                  <button type="button" onClick={fecharModal} className="px-4 py-2 rounded bg-gray-200 text-gray-700 hover:bg-gray-300">Cancelar</button>
                  <button type="submit" className="px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700">Salvar</button>
                </div>
              </form>
            </div>
          </div>
        )}
        {/* Modal de confirmação de exclusão */}
        {confirmarExclusao.aberto && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-sm relative">
              <h3 className="text-lg font-bold mb-4">Confirmar exclusão?</h3>
              <div className="flex justify-end gap-2 mt-6">
                <button onClick={cancelarRemocao} className="px-4 py-2 rounded bg-gray-200 text-gray-700 hover:bg-gray-300">Cancelar</button>
                <button onClick={confirmarRemocao} className="px-4 py-2 rounded bg-red-600 text-white hover:bg-red-700">Excluir</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ImpostosPage; 